export default __webpack_public_path__ + "129690d7e7f89a06822f37c632978a01.ttf";